import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
const Tag = ({ tag, className }) => (_jsx("span", { className: `badge badge-${tag.system ? "dark" : "primary"} ${className || ""}`, title: `${tag.system ? "Automatically Assigned:" : "Staff Assigned:"} ${tag.name}`, children: tag.name }));
export default Tag;
